export default {
  CONTEXTS: {
    CLINIC: 'CLINIC',
    LABORATORY: 'LABORATORY',
    PROFESSIONAL: 'PROFESSIONAL'
  }
}
